import { type StateCreator } from "zustand";

export type TGenericDataVisulization = {
  open: boolean;
  configType: string;
  params: Record<string, any> | null;
  title?: string; // Optional override title
};

export type TCommonStoreState = {
  globalDateFormat: string;
  featureShowHideFlag: string[];
  isSidebarToggle: boolean;
  isRecording: boolean;
  isOpenDataVisulizationModal: TGenericDataVisulization;
  globalFilterData: {
    startDate: string;
    endDate: string;
    dateType: string;
    entity: string;
    type: string;
    campaign_id?: string;
    service_id?: string;
    agent_id?: string;
    location?: string;
    searchType?: string;
    searchQuery?: string;
    country?: string;
    period: string;
  };
} & Partial<Record<string, any>>;

export type TCommonStoreActions = {
  setEntityFeatureFlagShowHide: (value: string[]) => void;
  setSidebarToggle: (value: boolean) => void;
  setIsRecording: (value: boolean) => void;
  setIsOpenDataVisulizationModal: (value: TGenericDataVisulization) => void;
  setGlobalFilterData: (data: {
    startDate: string;
    endDate: string;
    dateType: string;
    entity?: string;
    type?: string;
    campaign_id?: string;
    service_id?: string;
    agent_id?: string;
    location?: string;
    searchType?: string;
    searchQuery?: string;
    period?: string;
  }) => void;
  resetGlobalFilterData: () => void;
  setGlobalDateFormat: (value: string) => void;
};
const initialCommonStoreState: TCommonStoreState = {
  featureShowHideFlag: [],
  isSidebarToggle: false,
  isRecording: false,
  isOpenDataVisulizationModal: {
    open: false,
    configType: "",
    params: null,
    title: undefined,
  },
  globalFilterData: {
    startDate: "",
    endDate: "",
    dateType: "",
    entity: "",
    type: "",
    campaign_id: "",
    location: "",
    service_id: "",
    agent_id: "",
    searchType: "",
    searchQuery: "",
    period: "",
  },
  globalDateFormat: "",
};

export type TCommonStore = TCommonStoreActions & TCommonStoreState;

export const CreateCommonSlice: StateCreator<TCommonStore> = (set) => ({
  ...initialCommonStoreState,
  setGlobalDateFormat: (value: string) => set({ globalDateFormat: value }),
  setSidebarToggle: (value: boolean) => set({ isSidebarToggle: value }),
  setIsRecording: (value: boolean) => set({ isRecording: value }),
  setIsOpenDataVisulizationModal: (value: TGenericDataVisulization) =>
    set({ isOpenDataVisulizationModal: value }),
  setEntityFeatureFlagShowHide: (value: string[]) =>
    set({ featureShowHideFlag: value }),
  setGlobalFilterData: (data) =>
    set((state) => ({
      globalFilterData: {
        ...state.globalFilterData,
        ...data,
      },
    })),
  resetGlobalFilterData: () =>
    set({ globalFilterData: initialCommonStoreState.globalFilterData }),
});
